interface ReactNativeWebView {
  postMessage: (message: string) => void;
}

declare global {
  interface Window {
    ReactNativeWebView?: ReactNativeWebView;
  }
}

const isRunningInReactNativeWebView = () => {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    return true;
  }
  return false;
};
export default isRunningInReactNativeWebView;
